import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Sidebar from "../../components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import UserFormComponent from "../../components/UserForm";
import * as modalActions from "../../redux/actions/modalActions";
import * as commonActions from "../../redux/actions/commonAction";
import * as userAuthActions from "../../redux/actions/userAuthAction";
import { setLanguage } from "redux-i18n";
import { useParams, useLocation } from "react-router-dom";
import { LEVELS } from "../../App.config";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionComponent";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";

const UserForm = (props, context) => {

    const profileReducer = useSelector((state) => state.profileReducer);
    const commonReducer = useSelector((state) => state.commonReducer);
    const userAuthReducer = useSelector((state) => state.userAuthReducer);
    const in18Reducer = useSelector((state) => state.i18nState);


    const dispatch = useDispatch();
    const modalAction = bindActionCreators(modalActions, dispatch);
    const commonAction = bindActionCreators(commonActions, dispatch);
    const userAuthAction = bindActionCreators(userAuthActions, dispatch);

    const [formData, setFormData] = useState({});
    const [isPasswordFiedShown, setIsPasswordFiedShown] = useState(true);

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    const query = useQuery();

    useEffect(() => {
        // userAuthAction.getAuthUserRoles();
        if (query.get("authUserId")) {
            setIsPasswordFiedShown(false);
            userAuthAction.getAuthUserById(query.get("authUserId"));
        }
    }, [query.get("authUserId")]);

    useEffect(() => {
        // userAuthAction.getAuthUserRoles();
        if (userAuthReducer.isUserSet) {
            setFormData(userAuthReducer.authUser);
            userAuthAction.resetIsUserSet();
        }
    }, [userAuthReducer.isUserSet]);


    //for open modal
    const openSetModal = (children, size) => {
        modalAction.openSetModal(children, size);
    };

    //for closing modal
    const closeRemoveModal = () => {
        modalAction.closeRemoveModal();
    };

    //for changing language
    const languageChange = (language) => {
        dispatch(setLanguage(language));
    };

    const onMenuToggle = (isOpen) => {
        commonAction.setIsSideMenuOpen(isOpen);
    };

    const getAuthUserById = (authUserId) => {
        userAuthAction.getAuthUserById(authUserId);
    }


    return (
        <>
            {window.location.hash !== "#/" && (
                <Sidebar
                    languageChange={languageChange}
                    openSetModalAction={openSetModal}
                    closeRemoveModal={closeRemoveModal}
                    managersDetails={profileReducer.managersDetails}
                    onMenuToggle={onMenuToggle}
                    isSideMenuOpen={commonReducer.isSideMenuOpen}
                    context={context}
                />
            )}
            <div className="Content-Panel">
                <ShowForPermission module={PERMISSON_MODULES.USERS} permission={PERMISSION_TYPE.ADD}>
                    <UserFormComponent
                        levels={LEVELS}
                        userAuthReducer={userAuthReducer}
                        profileReducer={profileReducer}
                        userAuthAction={userAuthAction}
                        formData={formData}
                        isPasswordFiedShown={isPasswordFiedShown}
                        context={context}
                        getAuthUserById={getAuthUserById}
                        setIsPasswordFiedShown={setIsPasswordFiedShown}
                        in18Reducer={in18Reducer}
                    // query={query}
                    />
                </ShowForPermission>
            </div>
        </>
    );
};

UserForm.contextTypes = {
    t: PropTypes.func.isRequired,
};
export default UserForm;
